export function validateLuhnAlgorithm(cardNumber: string): boolean {
  let sum = 0
  let isEven = false

  for (let i = cardNumber.length - 1; i >= 0; i--) {
    let digit = Number.parseInt(cardNumber.charAt(i), 10)

    if (isEven) {
      digit *= 2
      if (digit > 9) {
        digit -= 9
      }
    }
    sum += digit
    isEven = !isEven
  }

  return sum % 10 === 0
}

export function detectCardType(cardNumber: string): string {
  const patterns: { [key: string]: RegExp } = {
    visa: /^4\d{12}(?:\d{3})?$/,
    mastercard: /^5[1-5]\d{14}$/,
    amex: /^3[47]\d{13}$/,
    discover: /^6(?:011|5\d{2})\d{12}$/,
  }

  for (const cardType in patterns) {
    if (patterns[cardType].test(cardNumber)) {
      return cardType
    }
  }

  return 'Unknown'
}

export function validateExpirationDate(
  expirationMonth: number,
  expirationYear: number,
): boolean {
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth() + 1 // January is 0

  if (expirationYear > currentYear) {
    return true
  }
  else if (
    expirationYear === currentYear
    && expirationMonth >= currentMonth
  ) {
    return true
  }

  return false
}

export function formatCardCVV(cvv: string) {
  const cvvPattern = /^\d{3,4}$/
  return cvvPattern.test(cvv)
}

export function formatCardNumber(value: string) {
  return value
    .replace(/\s+/g, '')
    .replace(/(\d{4})/g, '$1 ')
    .trim()
}

export function formatCardValidity(value: string) {
  if (value.length === 2 && !value.includes('/')) {
    value += '/'
  }
  return value
}
